"use client";

import React from "react";
import { SessionProvider } from "next-auth/react";
import { Provider as ReduxProvider } from "react-redux";
import store from "../../../store/store";
import { MediaProvider, ReservationProvider, ProviderProvider } from "ui/context";
import ViewModeSessionPatcher from "./ViewModeSessionPatcher";

interface IRootClientProvidersProps {
  children: React.ReactNode;
}

export default function RootClientProviders({ children }: IRootClientProvidersProps) {
  return (
    <ReduxProvider store={store}>
      <SessionProvider refetchInterval={300} refetchOnWindowFocus={true}>
        <ViewModeSessionPatcher>
          <ProviderProvider>
            <ReservationProvider>
              <MediaProvider>{children}</MediaProvider>
            </ReservationProvider>
          </ProviderProvider>
        </ViewModeSessionPatcher>
      </SessionProvider>
    </ReduxProvider>
  );
}